import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorTransactionOrderTopChecking = () => {
  const transactionOrderTopChecking = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/transaction/order-header/top-checking', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])

  return { transactionOrderTopChecking }
}

export default InteractorTransactionOrderTopChecking
